// Constantes de cor usadas em todo o app. Importar daqui, não redefinir por arquivo.

export const ABC_COLOR: Record<string, string> = {
  A: 'bg-mbc-orange/25 text-mbc-orangel',
  B: 'bg-mbc-blue/25 text-mbc-bluel',
  C: 'bg-slate-500/20 text-slate-300',
};

export const STATUS_COLOR: Record<string, string> = {
  Zerado:      'bg-rose-500/20 text-rose-300',
  Crítico:     'bg-amber-500/20 text-amber-300',
  Saudável:    'bg-emerald-500/20 text-emerald-300',
  Excesso:     'bg-sky-500/20 text-sky-300',
  'Sem venda': 'bg-slate-500/20 text-slate-300',
};

export const MARGIN_COLOR: Record<string, string> = {
  Aprovado:   'bg-emerald-500/20 text-emerald-300',
  Negociar:   'bg-amber-500/20 text-amber-300',
  Bloqueado:  'bg-rose-500/20 text-rose-300',
  'Sem dado': 'bg-slate-500/20 text-slate-300',
  '—':        'bg-slate-500/20 text-slate-400',
};

export const WF_COLOR: Record<string, string> = {
  pendente:          'bg-slate-500/20 text-slate-300',
  cot_recebida:      'bg-sky-500/20 text-sky-300',
  em_validacao:      'bg-violet-500/20 text-violet-300',
  aprov_comercial:   'bg-emerald-500/20 text-emerald-300',
  reprov_comercial:  'bg-rose-500/20 text-rose-300',
  aguard_financeiro: 'bg-amber-500/20 text-amber-300',
  aprov_financeiro:  'bg-teal-500/20 text-teal-300',
  pedido:            'bg-mbc-blue/25 text-mbc-bluel',
  agendado:          'bg-cyan-500/20 text-cyan-300',
  receb_parcial:     'bg-indigo-500/20 text-indigo-300',
  receb_total:       'bg-green-500/20 text-green-300',
  aprovado:          'bg-emerald-500/20 text-emerald-300',
  cotado:            'bg-amber-500/20 text-amber-300',
};

export const WF_LABEL: Record<string, string> = {
  pendente:          'Aguardando cotação',
  cot_recebida:      'Cotação recebida',
  em_validacao:      'Em validação comercial',
  aprov_comercial:   'Aprovado comercial',
  reprov_comercial:  'Reprovado comercial',
  aguard_financeiro: 'Aguardando financeiro',
  aprov_financeiro:  'Aprovado financeiro',
  pedido:            'Pedido emitido',
  agendado:          'Agendado',
  receb_parcial:     'Recebido parcial',
  receb_total:       'Recebido total',
  aprovado:          'Aprovado',
  cotado:            'Cotado',
};

export const PO_STATUS_COLOR: Record<string, string> = {
  'Aguardando aprovação': 'bg-amber-500/20 text-amber-300',
  'Aprovado':             'bg-emerald-500/20 text-emerald-300',
  'Rejeitado':            'bg-rose-500/20 text-rose-300',
  'Pago parcial':         'bg-sky-500/20 text-sky-300',
  'Pago total':           'bg-emerald-500/40 text-emerald-200',
  'Recebido':             'bg-mbc-blue/25 text-mbc-bluel',
};

// Cores das semanas (semanas 1–5 do mês). Usado em Financeiro e Cronograma.
export const SEM_COLORS: Record<number, string> = {
  1: '#0A4D9E', 2: '#1E6FD6', 3: '#F47A20', 4: '#FB9D4B', 5: '#22a06b',
};
